/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Faq_A7Inputs */

const en_to_yaml_faq_a7 = /** @type {(inputs: To_Yaml_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is a folded block scalar, used for strings longer than the 120 character line width. The following lines are joined back into one line when read, and the minus suffix strips the trailing newline. The value round trips exactly.`)
};

const ko_to_yaml_faq_a7 = /** @type {(inputs: To_Yaml_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`접힌 블록 스칼라이며, 120자 줄 너비보다 긴 문자열에 쓰입니다. 이어지는 줄들은 읽을 때 한 줄로 다시 합쳐지고, 빼기 접미사는 마지막 줄바꿈을 없앱니다. 값은 정확하게 왕복합니다.`)
};

const ja_to_yaml_faq_a7 = /** @type {(inputs: To_Yaml_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`畳み込みブロックスカラーで、120 文字の行幅より長い文字列に使われます。続く行は読むときに 1 行へ戻され、マイナスの接尾辞が末尾の改行を取り除きます。値は正確に往復します。`)
};

/**
* | output |
* | --- |
* | "It is a folded block scalar, used for strings longer than the 120 character line width. The following lines are joined back into one line when read, and the ..." |
*
* @param {To_Yaml_Faq_A7Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_faq_a7 = /** @type {((inputs?: To_Yaml_Faq_A7Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Faq_A7Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_faq_a7(inputs)
	if (locale === "ko") return ko_to_yaml_faq_a7(inputs)
	return ja_to_yaml_faq_a7(inputs)
});